import { Grid, ColumnMenu as GridColumnMenu } from '@syncfusion/ej2-grids';
/**
 * TreeGrid ColumnMenu module
 *
 * @hidden
 */
export class ColumnMenu {
    /**
     * Constructor for render module
     *
     * @param {TreeGrid} parent - Tree Grid instance
     */
    constructor(parent) {
        Grid.Inject(GridColumnMenu);
        this.parent = parent;
    }
    getColumnMenu() {
        return this.parent.grid.columnMenuModule.getColumnMenu();
    }
    destroy() {
        //this.parent.grid.columnMenuModule.destroy();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} Returns ColumnMenu module name
     */
    getModuleName() {
        return 'columnMenu';
    }
}
